import * as actionConstants from "../../constants/action-types";

const initialState = {
    customerLookupResults: [],
    customerLookupDetail: [],
    customerLookupDetailUpdate: [],
    customerLookupWebHistory: [],
    customerLookupWebSummary: [],
    customerLookupEmailHistory: [],
    // V2's envelope. Seeded with the full shape so the tab can read `.rows`
    // unconditionally, before the fetch resolves and if it fails.
    customerLookupEmailHistoryV2: {
        rows: [],
        degraded: false,
        // False, not true, in the initial state: nothing has been attempted yet, and the
        // tab's `loaded` flag is what distinguishes "still loading" from "came back empty".
        fetchFailed: false,
    },
    customerLookupEmailSummary: [],
    customerLookupTransactionHistory: [],
    customerLookupTransactionSummary: [],
    customerLookupReservationHistory: [],
    reservationHistoryColumnsName: [],
    customerProductReg: []
};

const CustomerManagementReducer = (state = initialState, action) => {
    //console.log('in CustomerManagementReducer', action);
    switch (action.type) {
        case actionConstants.CUSTOMER.CUSTOMER_LOOKUP_GET_RESULT: {
            return Object.assign({}, state, {
                customerLookupResults: action.payload
            });
        }

        case actionConstants.CUSTOMER.CUSTOMER_LOOKUP_SET_EMPTY: {
            return Object.assign({}, state, {
                customerLookupResults: null
            });
        }

        case actionConstants.CUSTOMER.CUSTOMER_LOOKUP_GET_DETAIL: {
            return Object.assign({}, state, {
                customerLookupDetail: action.payload
            });
        }

        case actionConstants.CUSTOMER.CUSTOMER_LOOKUP_UPDATE_DETAIL: {
            return Object.assign({}, state, {
                customerLookupDetailUpdate: action.payload
            });
        }

        case actionConstants.CUSTOMER.CUSTOMER_LOOKUP_GET_WEB_HISTORY: {
            return Object.assign({}, state, {
                customerLookupWebHistory: action.payload
            });
        }

        case actionConstants.CUSTOMER.CUSTOMER_LOOKUP_GET_WEB_SUMMARY: {
            return Object.assign({}, state, {
                customerLookupWebSummary: action.payload
            });
        }

        case actionConstants.CUSTOMER.CUSTOMER_LOOKUP_GET_EMAIL_HISTORY: {
            return Object.assign({}, state, {
                customerLookupEmailHistory: action.payload
            });
        }

        case actionConstants.CUSTOMER.CUSTOMER_LOOKUP_GET_EMAIL_HISTORY_V2: {
            return Object.assign({}, state, {
                customerLookupEmailHistoryV2: action.payload
            });
        }

        case actionConstants.CUSTOMER.CUSTOMER_LOOKUP_GET_CUSTOMER_PRODUCT_REG: {
            return Object.assign({}, state, {
                customerProductReg: action.payload
            });
        }
 
        case actionConstants.CUSTOMER.CUSTOMER_LOOKUP_GET_EMAIL_SUMMARY: {
            return Object.assign({}, state, {
                customerLookupEmailSummary: action.payload
            });
        }

        case actionConstants.CUSTOMER.CUSTOMER_LOOKUP_GET_TRANSACTION_HISTORY: {            
            return Object.assign({}, state, {
                customerLookupTransactionHistory: action.payload
            });
        }

        case actionConstants.CUSTOMER.CUSTOMER_LOOKUP_GET_TRANSACTION_SUMMARY: {
            return Object.assign({}, state, {
                customerLookupTransactionSummary: action.payload
            });
        }

        case actionConstants.CUSTOMER.CUSTOMER_LOOKUP_GET_RESERVATION_HISTORY: {
            return Object.assign({}, state, {
                customerLookupReservationHistory: action.payload
            });
        }

        case actionConstants.CUSTOMER.RESERVATION_HISTORY_COLUMNS_NAME: {
            return Object.assign({}, state, {
                reservationHistoryColumnsName: action.payload
            });
        }

        default:
            return state;
    }
}

export default CustomerManagementReducer;
